import { ITEMS, CHARACTERS } from '../data';
import { ASSETS } from '../assetManifest';

export const getPullData = (id) => {
  // Check if it's a character
  if (CHARACTERS[id]) {
    return {
      type: 'character',
      name: CHARACTERS[id].name,
      image: ASSETS.characters[id].path,
      stars: CHARACTERS[id].stats.stars || 5,
      subtitle: CHARACTERS[id].subtitle || 'A mysterious warrior'
    };
  }
  
  // Otherwise treat as item
  if (ITEMS[id]) {
    return {
      type: 'item',
      name: ITEMS[id].name,
      image: ASSETS.items[id].path,
      stars: ITEMS[id].rarity,
      subtitle: ITEMS[id].description
    };
  }

  throw new Error(`Unknown pull id: ${id}`);
};

export const getPullsData = (ids) => {
  return ids.map(id => getPullData(id));
};
